module.exports = __webpack_public_path__ + "static/media/AW.766714d6.svg";